export const AI_SOURCE_MAIN = '邮小率';
export const AI_SOURCE_EXPERIMENT = '实验问答';
export const AI_SOURCE_QUESTION = '题目问答';
export const AI_SOURCE_MINDMAP = '思维问答';
export const AI_SOURCE_CLASS_ANALYSIS = '班级学情分析';

export type AiConversationSource
  = | typeof AI_SOURCE_MAIN
    | typeof AI_SOURCE_EXPERIMENT
    | typeof AI_SOURCE_QUESTION
    | typeof AI_SOURCE_MINDMAP
    | typeof AI_SOURCE_CLASS_ANALYSIS;
